import bgImage from '../../assets/background.png';

/** Full-screen landing page shown before the idle menu. */
export function LandingScreen({ onEnter }) {
  return (
    <div className="landing-screen" style={{ backgroundImage: `url(${bgImage})` }}>
      <div className="landing-bg" />
      <div className="landing-content">
        <div className="landing-title-wrap">
          <h1 className="landing-title">PATH OF SURVIVOR</h1>
          <p className="landing-subtitle">How long can you last?</p>
        </div>
        <button className="landing-enter-btn" onClick={onEnter}>
          Enter
        </button>
      </div>
    </div>
  );
}
